import styled from 'styled-components';

export const Container = styled.div`
    max-width: 800px;
    margin: var(--spacer-L) auto;
    padding: var(--spacer-M);
    background: var(--bg-light);
    border: 1px solid var(--appLigthGrey);
    border-radius: var(--spacer-S);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

export const Header = styled.div`
    text-align: center;
    margin-bottom: var(--spacer-M);
    padding-bottom: var(--spacer-S);
    border-bottom: 1px solid var(--appLigthGrey);
`;

export const CompanyLogo = styled.img`
    max-width: 200px;
    max-height: 80px;
    margin-bottom: var(--spacer-S);
    display: block;
    margin-left: auto;
    margin-right: auto;
`;

export const CompanyName = styled.h2`
    font-size: 1.4rem;
    color: var(--text-body);
    margin-bottom: var(--spacer-S);
    font-weight: 600;
`;

export const Title = styled.h1`
    font-size: 1.6rem;
    color: var(--text-body);
    margin-bottom: var(--spacer-XS);
`;

export const Subtitle = styled.p`
    color: var(--text-muted);
    font-size: 1rem;
`;

export const ConsentBox = styled.div`
    margin: var(--spacer-S) 0;
    padding: var(--spacer-S);
    background: var(--bg-light);
    border-radius: var(--spacer-S);
    border-left: var(--border-thick) solid var(--info-color);
`;

export const ConsentText = styled.div`
    font-size: var(--font-XS);
    line-height: 1.6;
    color: var(--text-body);
    margin-bottom: var(--spacer-S);
`;

export const SubConsentItem = styled.div`
    display: flex;
    align-items: center;
    padding: var(--spacer-XS) 0;
    padding-left: var(--spacer-S);
    font-size: 0.95rem;
    color: var(--text-body);
`;

export const MandatoryBadge = styled.span`
    color: var(--danger-color);
    font-size: 0.85em;
    font-weight: 600;
    margin-left: var(--spacer-XS);
`;

export const WarningBox = styled.div`
    background: var(--warning-bg);
    border-left: 4px solid var(--warning-color);
    padding: var(--spacer-S);
    margin: var(--spacer-S) 0;
    border-radius: 4px;
    font-size: 0.875rem;
`;

export const LoadingContainer = styled.div`
    text-align: center;
    padding: var(--spacer-L);
`;

export const LoadingText = styled.p`
    margin-top: var(--spacer-S);
    color: var(--text-muted);
`;

export const SuccessContainer = styled.div`
    text-align: center;
    padding: var(--spacer-L);
`;

export const SuccessIcon = styled.div`
    font-size: var(--font-L);
    margin-bottom: var(--spacer-S);
    color: var(--success-color);
`;

export const SuccessText = styled.p`
    color: var(--text-muted);
    font-size: 1rem;
    margin-top: var(--spacer-S);
`;

export const SuccessSubtext = styled.p`
    color: var(--text-muted);
    font-size: 0.875rem;
    margin-top: var(--spacer-XS);
`;

export const LinksContainer = styled.div`
    margin-top: var(--spacer-S);
    font-size: 0.875rem;
    text-align: center;
`;

export const LinkItem = styled.div`
    margin-top: var(--spacer-XXS);
`;

export const StyledLink = styled.a`
    color: var(--info-color);
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const SubmitButtonContainer = styled.div`
    text-align: center;
    margin-top: var(--spacer-M);
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: flex-start;
    cursor: pointer;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
    margin-top: var(--spacer-XXS);
    margin-right: var(--spacer-XS);
    min-width: var(--spacer-S);
    min-height: var(--spacer-S);
`;

export const SubConsentsContainer = styled.div`
    margin-top: var(--spacer-XS);
    padding-left: var(--spacer-M);
`;

export const SubConsentCheckbox = styled.input.attrs({ type: 'checkbox' })`
    margin-right: var(--spacer-XS);
`;
